<template>
  <div v-if="qrCode" class="qr-code"><img :src="qrCode" :s-id="sId"></div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    computed: mapState(['qrCode', 'subId']),
    methods: mapActions(['getQRCode']),
    created() {
      if(!this.qrCode && this.subId > 0) {
        this.getQRCode(this.subId)
      }
    }
  };
</script>
